module.exports = __webpack_public_path__ + "static/olatinwo-2a4b88d320b9abd19ad5cc831246b6fb.jpg";